import type { Schema } from 'effect';

import type { BackendApiErrorUnion } from '../../data/error/backendApi/_internal/createBackendApiError';
import { makeListCategoryRootMenu } from '../../request/backendApi/taxon/makeListCategoryRootMenu';
import { makeListTaxonTree } from '../../request/backendApi/taxon/makeListTaxonTree';

/** Engine-side taxon module, composed from its original request factories. */
export type TaxonModuleDeps<TaxonMenu extends Schema.Top> = {
  readonly taxonMenu: TaxonMenu;
};

export const makeTaxonModule = <TaxonMenu extends Schema.Top>(deps: TaxonModuleDeps<TaxonMenu>) => {
  const rootMenu = makeListCategoryRootMenu({ taxonMenu: deps.taxonMenu });
  const tree = makeListTaxonTree({ taxonMenu: deps.taxonMenu });

  return {
    listCategoryRootMenu: rootMenu.listCategoryRootMenu,
    ListCategoryRootMenuError: rootMenu.ListCategoryRootMenuError,
    listTaxonTree: tree.listTaxonTree,
    ListTaxonTreeError: tree.ListTaxonTreeError,
  };
};

export type CategoryListRootMenuError = BackendApiErrorUnion<
  ReturnType<typeof makeTaxonModule>['ListCategoryRootMenuError']
>;
export type TaxonListTreeError = BackendApiErrorUnion<
  ReturnType<typeof makeTaxonModule>['ListTaxonTreeError']
>;
